enum GeneralAndAcademic {
  Academic = 'IELTS Academic',
  General = 'IELTS General Training'
}

export const getTestFormat = (bookableProductName: string) => {
  if (bookableProductName.toLowerCase().includes('on computer')) {
    return 'IELTS on computer'
  } else if (bookableProductName.toLowerCase().includes('on paper')) {
    return 'IELTS on paper'
  } else {
    return ''
  }
}

// newwwwwwwwwwwwwwwwwwwwwwwwwww

export const getNewTestFormat = (bookableProductName: string) => {
  const lowerCaseName = bookableProductName?.toLowerCase() || ''
  if (lowerCaseName.includes('on-computer') || lowerCaseName.includes('paper-based')) {
    return 'IELTS on computer'
  } else if (lowerCaseName.includes('on-paper')) {
    return 'IELTS on Paper'
  } else if (lowerCaseName.includes('online')) {
      return 'Online'
  } else {
    return ''
  }
}

export const getTestType = (bookableProductName: string) => {
  const productInclude = mainProductInclude(bookableProductName)
  if (productInclude('life skills')) {
    if (productInclude('a1')) {
      return 'Life Skills A1'
    } else if (productInclude('b1')) {
      return 'Life Skills B1'
    } else {
      return ''
    }
  } else if (productInclude('SELT') || productInclude('UKVI')) {
    return `IELTS UKVI on ${extractGeneralOrAcademic(bookableProductName).replace(new RegExp('IELTS ', 'g'), '')}`
  }
  return extractGeneralOrAcademic(bookableProductName)
}

const mainProductInclude = (bookableProductName: any) => (keyword: any) => bookableProductName.toLowerCase().includes(keyword.toLowerCase())

function extractGeneralOrAcademic (productName: any): GeneralAndAcademic.Academic | GeneralAndAcademic.General | '-' {
  const productInclude = mainProductInclude(productName)
  if (productInclude('GT') || productInclude('General Training')) {
    return GeneralAndAcademic.General
  } else if (productInclude('AC') || productInclude('Academic')) {
    return GeneralAndAcademic.Academic
  }
  return '-'
}

export const getNewWritingFormat = (bookableProductName: string) => {
  const lowerCaseName = bookableProductName?.toLowerCase() || ''
  if (lowerCaseName.includes('writing on paper')) {
    return 'Writing on paper'
  } else if (lowerCaseName.includes('on computer')) {
    return 'Writing on computer'
  }else {
    return ''
  }
}
